import "../pages/css/App.css";
import "../pages/css/WhiskyCreate.css";
import frontendLogger from "../utils/frontendLogger.js";
import useAuthUser from "../hooks/useAuthUser.js";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { logout } from "../hooks/logout.js";
import { API_BASE_URL } from "../app_config.js";

function DistilleryDataCreate() {
  const { userId } = useAuthUser();
  const [distilleryName, setDistilleryName] = useState("");
  const [country, setCountry] = useState("");
  const [region, setRegion] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleBackToStart = () => {
    navigate("/main");
  };
  const handleSaveDistillery = async (e) => {
    e.preventDefault();

    if (!userId) {
      setErrorMessage(
        "Benutzer-ID noch nicht geladen. Bitte versuchen Sie es später.",
      );
      return;
    }

    setErrorMessage("");
    setSuccessMessage("");

    const distilleryData = {
      name: distilleryName,
      country: country,
      region: region,
    };

    frontendLogger.info("Speichere Destillerie:", distilleryData);

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_BASE_URL}/api/distilleryDataCreate/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(distilleryData),
        },
      );

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Fehler beim Speichern der Destillerie: ${text}`);
      }

      setSuccessMessage("Destillerie erfolgreich gespeichert!");

      setTimeout(() => {
        setDistilleryName("");
        setCountry("");
        setRegion("");
      }, 2000);
    } catch (error) {
      frontendLogger.error("Fehler beim Speichern der Destillerie:", error);
      setErrorMessage(error.message);
    }
  };

  return (
    <div className="page-layout">
      <div className="menu-container">
        <div className="title-box">
          <p>Willkommen bei DRAM</p>
        </div>
        <div className="menu-box">
          <h1>Destillerie anlegen</h1>
        </div>

        <nav className="nav">
          <button className="nav-button" onClick={handleBackToStart}>
            Startseite
          </button>

          <button
            className="nav-button"
            type="submit"
            form="distilleryForm"
            disabled={!userId}
          >
            Destillerie speichern
          </button>

          <button className="nav-button" onClick={() => logout(navigate)}>
            Abmelden
          </button>
        </nav>
        <img
          src={require("../assets/logo.png")}
          alt="Versionsinformationen anzeigen"
          className="whisky-image"
          role="button"
          tabIndex={0}
        />
      </div>
      <div className="whisky-form-group">
        {successMessage && (
          <div className="success-message">{successMessage}</div>
        )}
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        <form id="distilleryForm" onSubmit={handleSaveDistillery}>
          <label htmlFor="distilleryName">Name der Destillerie:</label>
          <input
            type="Name"
            id="distilleryName"
            value={distilleryName}
            placeholder="Name der Destillerie"
            onChange={(e) => setDistilleryName(e.target.value)}
            required
          />

          <label htmlFor="country">Land:</label>
          <input
            type="Land"
            id="country"
            value={country}
            placeholder="Herkunftsland z.B. Schottland"
            onChange={(e) => setCountry(e.target.value)}
            required
          />

          <label htmlFor="region">Region:</label>
          <input
            type="Region"
            id="region"
            value={region}
            placeholder="Region z.B. Speyside"
            onChange={(e) => setRegion(e.target.value)}
            required
          />
        </form>
      </div>
    </div>
  );
}

export default DistilleryDataCreate;
